import { render } from "./TodaySchedule.vue?vue&type=template&id=136a60d4&scoped=true&ts=true"
import script from "./TodaySchedule.vue?vue&type=script&lang=ts"
export * from "./TodaySchedule.vue?vue&type=script&lang=ts"

import "./TodaySchedule.vue?vue&type=style&index=0&id=136a60d4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-136a60d4"]])

export default __exports__